import {
  CheckIcon,
  FileUpload,
  CircularLoader,
  Card,
  CardHeader,
} from "@forge/common";
import React, { useState } from "react";
import { BodyText, NormalText } from "../../common/components/title-container/LText";
import { HeaderComponent, FooterComponent } from "../popup";
import "./iso-popup.scss";
import { useDispatch } from "react-redux";
import { ISO_FILE_MANAGEMENT_CONSTANTS } from "../utils/constant";
import { btnResponsive } from "../../common/utils/helper";
import { rendererFileSizeCol } from "../../file-management/utils/helper";


const UploadIso = ({
  title,
  description,
  selectedItems,
  btnText1,
  btnText,
  onCancel,
  onTrigger,
}: {
  title: string;
  description?: string;
  selectedItems?: any[];
  btnText1?: string;
  btnText?: string;
  onCancel: () => void;
  onTrigger: (files: File[]) => void;
}) => {
  const disptach = useDispatch()
  const [error,setError] = useState<string | null>(null)
  const [fileList, setFileList] = React.useState<File[]>([]);

  const onFileUpload = (fileList: FileList) => {
     setError(null)
    // Check if the total file size exceeds 15 GB
    const totalSize = Array.from(fileList).reduce((acc, file) => acc + file.size, 0);
    if (totalSize > 15 * 1024 * 1024 * 1024) {
      setError(ISO_FILE_MANAGEMENT_CONSTANTS.TOTAL_UPLOAD_SIZE_CANNOT_EXCEED)
      return;
    }
    
    const maxFileName =  Array.from(fileList).filter(file => file.name?.length > 128)

     if (maxFileName.length > 0) {
       setError(ISO_FILE_MANAGEMENT_CONSTANTS.MAX_FILE_NAME)
      return;
    }
    // Check if all files are ISO format
    const nonIsoFiles = Array.from(fileList).filter(file => !file.name.toLowerCase().endsWith('.iso'));
    if (nonIsoFiles.length > 0) {
       setError(ISO_FILE_MANAGEMENT_CONSTANTS.FILES_PERMITTED)
      return;
    }

    setFileList((prev) => [...prev, ...Array.from(fileList)]);
  };

  return (
    <Card className="mx-auto w-full border-[0px] border-card-none bg-[#202020]">
      <div className="flexContainer flexDirection-column w-[400px] h-[400px] xl-high:w-[600px] xl-high:h-[600px]">
        <HeaderComponent title={title} onCancel={onCancel} />
        <div className="mt-5">
          <FileUpload
            data-testid="file-input"
            accept={["text/json"]}
            containerClassName="custom-fileupload h-[65px]"
            i18nBrowse="Browse for files"
            i18nDragDrop="Drag and drop here"
            i18nOr="or"
            id="file-upload"
            onFileUpload={onFileUpload}
            orientation="horizontal"
            variant="drag-drop"
            disabled={fileList?.length !== 0}
            error={error!==null}
          />
        </div>
        {error && <NormalText title={error} className="text-xs font-medium !text-[#FF644C] mt-1 text-center" />}
        <div className="mt-2">
           <NormalText
            className={`text-xs ${btnResponsive("text-xs")} xl-high:mt-3 font-medium text-[#D0D0D0] text-center`}
            title={"Only ISO files are permitted."}
          />
          <NormalText
            className={`text-xs ${btnResponsive("text-xs")} font-medium text-[#D0D0D0] mt-1 text-center`}
            title={"Total upload size cannot exceed 15 GB."}
          />
           <NormalText
            className={`text-xs ${btnResponsive("text-xs")} xl-high:mt-3 font-medium text-[#D0D0D0] mt-1 text-center`}
            title={"Please do not refresh or close the page while upload is in progress."}
          />
        </div>
        <div className="overflow-auto h-[200px] xl-high:h-[400px]  mt-3">
          {fileList?.map((file: File, index: number) => {
            return (
              <div
                className="w-100 border-t-[1px] border-black cardListing"
                key={index}
              >
                <CardHeader
                  avatar={
                    <div className="flexContainer mt-[15px] h-100 alignItems-center justify-center gap-2">
                      <div className="gradient-border">
                        <div className="transparent-circle"></div>
                      </div>
                    </div>
                  }
                  slotRight={
                    <div className="flexContainer mt-[15px] h-100 alignItems-center justify-center gap-2">
                      <CheckIcon className="text-xl cursor-pointer text-[#5A8028] font-bold" />
                    </div>
                  }
                >
            <div className="w-60 overflow-hidden text-ellipsis mt-2">
                  <NormalText
                    title={file.name}
                    className={`text-xs ${btnResponsive("text-xs")} leading-[32px] xl-high:min-h-[30px] font-medium text-[#D0D0D0] truncate`}
                  />
                  </div>
                  <NormalText
                    title={rendererFileSizeCol(file.size?.toString())}
                    className={`text-xs ${btnResponsive("text-xs")} leading-[32px] font-medium text-[#A0A0A0] ml-2`}
                  />
                </CardHeader>
              </div>
            );
          })}
        </div>
        <div className="flexContainer justify-center items-end mt-4">
          <FooterComponent
            btnText1={btnText1}
            btnText={btnText}
            onCancel={onCancel}
            onTrigger={() => onTrigger(fileList)}
            disabled={fileList?.length === 0}
          />
        </div>
      </div>
    </Card>
  );
};

export default UploadIso;
